import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Input } from "./Input.js";
/**
 * Kanonisches Zahlenfeld für moderne Oberflächen.
 *
 * Das Primitiv hält Zahlen-spezifisches Verhalten aus den einzelnen Seiten
 * heraus. Insbesondere bleibt ein kontrolliertes Feld beim Löschen während
 * der Bearbeitung leer, selbst wenn ein Consumer `Number("")` als 0 speichert.
 */
export const NumberInput = forwardRef(function NumberInput(props, ref) {
    return _jsx(Input, { ref: ref, ...props, type: "number" });
});
